import {
  ApiCreateMyWishlistFailedAction,
  ApiCreateMyWishlistSucceededAction,
  apiCreateMyWishlistFailedType,
  apiCreateMyWishlistRequested,
  apiCreateMyWishlistSucceededType
} from '@spa/lib/store/api/wishlists/createMyWishlistApi';
import {
  CreateMyWishlistRequestedAction,
  addProductToMyWishlistRequested,
  createMyWishlistFailed,
  createMyWishlistSucceeded
} from '@spa/lib/store/wishlists/wishlistsSlice';
import { AnalyticsProduct } from '@spa/lib/tracking/productsToAnalyticsItemConverter';
import generateActionId from '@spa/lib/generateActionId';
import { put } from 'typed-redux-saga';
import waitForSucceededOrFailedAction from '@spa/lib/store/sagas/session/waitForSucceededOrFailedAction';

function* createMyWishlistSaga({
  payload: {
    actionId: requestedActionId,
    input,
    isDefault,
    listAttribution,
    origin,
    products,
    deletedWishlist
  }
}: CreateMyWishlistRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(
    apiCreateMyWishlistRequested({
      actionId,
      input,
      parentActionId: requestedActionId
    })
  );

  const waitResult = yield* waitForSucceededOrFailedAction<
    typeof apiCreateMyWishlistSucceededType,
    typeof apiCreateMyWishlistFailedType,
    ApiCreateMyWishlistSucceededAction,
    ApiCreateMyWishlistFailedAction
  >(actionId, apiCreateMyWishlistSucceededType, apiCreateMyWishlistFailedType);

  if (waitResult.type === 'succeeded') {
    yield* put(
      createMyWishlistSucceeded({ requestedActionId, wishlist: waitResult.action.payload.result })
    );
    if (origin !== undefined && products !== undefined && isDefault !== undefined) {
      for (const product of products) {
        const { code, quantity }: AnalyticsProduct = product;
        yield* put(
          addProductToMyWishlistRequested({
            actionId: requestedActionId,
            input: {
              itemSku: code,
              quantity: quantity ?? 1,
              wishlistId: waitResult.action.payload.result.id
            },
            isDefault,
            listAttribution,
            product,
            deletedWishlist
          })
        );
      }
    }
  } else {
    yield* put(
      createMyWishlistFailed({
        error: waitResult.action.payload.error,
        requestedActionId
      })
    );
  }
}

export default createMyWishlistSaga;
